import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { GridProps } from '@tq/ui-components';

import { useConsultees } from 'api';
import { filterAssigneeState, searchAssignedToMeState } from 'store';
import { ConsultationFilterMultiSelect } from 'components';

export const ConsultationAssigneeFilter: React.FC<GridProps> = ({ ...stylingProps }) => {
  const { t } = useTranslation('filter');
  const assignedToMe = useRecoilValue(searchAssignedToMeState);
  const { data: consulteeData } = useConsultees();
  return (
    <>
      {!assignedToMe && (
        <ConsultationFilterMultiSelect
          label={t('assignee_title', 'Assignee')}
          items={consulteeData?.consultees ?? []}
          state={filterAssigneeState}
          {...stylingProps}
        />
      )}
    </>
  );
};
